import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getIntegrations } from '../../services/integrations';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';

const Integrations = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [integrations, setIntegrations] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayIntegrations(currentPage);
  }, [page, isOrdering, isSearching]);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const displayIntegrations = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: integrations } = await getIntegrations(currentPage || page, params);

      setIntegrations(integrations.rows);
      setTotalItems(integrations.count);
      setTotalPages(integrations.pages);
      setPage(integrations.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['id', 'enotasId', 'createdAt', 'updatedAt', 'deletedAt', 'openApiId'];

  const SearchBoxHeaders = ['id', 'enotasId', 'openApiId'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Integrations ({totalItems})</h1>
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={integrations}
        action={true}
        bodyColumn={headers}
        linkPath={'integrations'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Integrations;
